/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import IconBase from './icon-base';

// Alternate info icon, default black background with white border; used for image attribution in Fleetwood tenant
const IconInfoAlt = ({ className, fill = '#000000', height = '26px', hoverColor = '#000000', stroke='#FFFFFF', width = '26px' }) => (
  <IconBase className={className} fill={fill} height={height} hoverColor={hoverColor} viewBox="0 0 26 26" width={width}>
    <circle cx="13" cy="13" r="12.4" fill={fill} stroke={stroke} strokeWidth="1" />
    <path
      d="M13.4,19.2c.2,0,.5,0,.7-.1h0c-.2.2-.5.4-.9.6-.4.2-.8.2-1.2.2s-.8-.1-.9-.4c-.1-.2-.2-.4-.2-.7s0-.4,0-.7l1.1-5.4c0-.2,0-.5,0-.7-.1-.2-.4-.3-.6-.4h-.5c0,0,0-.2,0-.2l3.1-.4-1.5,7c0,.3,0,.6,0,.8.1.2.4.3.7.3Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="0.75"
    />
    <path
      d="M14.3,7.5c0,.3-.1.7-.4.9-.2.2-.6.4-.9.4s-.7-.1-.9-.4c-.2-.2-.4-.6-.4-.9s.1-.7.4-.9.6-.4.9-.4.7.1.9.4.4.6.4.9Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="0.75"
    />
  </IconBase>
);

export default IconInfoAlt;
